import { localListAddItem, localListDeleteItem, localListUpdateItem } from '@/store/utils'
import axios from '@axios'
import moment from 'moment'

const getInitialState = () => ({
  event: {
    id: null,
    storeId: null,
    priceTableId: null,
    name: null,
    description: null,
    startDate: { date: null, time: null },
    endDate: { date: null, time: null },
    skus: [],
    bannersAtm: [],
  },
})

/** API devolve DateTimeOffset; a tela usa data e hora em inputs separados. */
const splitDateTime = value => {
  if (!value) return { date: null, time: null }
  return {
    date: moment(value).format('yyyy-MM-DD'),
    time: moment(value).format('HH:mm'),
  }
}

/**
 * Junta os dois inputs num ISO para a API. Sem data não há período: envia null.
 * Hora vazia assume o limite do dia (início 00:00, fim 23:59), para que informar só as datas
 * cubra o dia inteiro do evento.
 */
const joinDateTime = (value, defaultTime) => {
  const { date, time } = value || {}
  if (!date) return null
  const day = moment(date).format('YYYY-MM-DD')
  return moment(`${day} ${time || defaultTime}`, 'YYYY-MM-DD HH:mm').format()
}

export const getInitialItemForm = () => ({
  id: null,
  quantity: 1,
  quantityAdded: null,
  quantityRemoved: null,
  /** Estoque disponível do SKU na loja do evento, devolvido pelo GET do evento. */
  availableStock: null,
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    getSkus(state) {
      return state.event.skus.filter(p => !p.isDeleted)
    },

    getEventBannersAtm(state) {
      return state.event.bannersAtm
    },
  },

  mutations: {
    SET_EVENT(state, { event }) {
      state.event = event
    },
    SET_EVENT_STORE_ID(state, { storeId }) {
      state.event.storeId = storeId
    },
    SET_EVENT_STORE(state, { store }) {
      state.event.store = store
    },
    SET_SKUS(state, { skus }) {
      state.event.skus = skus
    },
    SET_BANNERS_ATM(state, { bannersAtm }) {
      state.event.bannersAtm = bannersAtm
    },
    CLEAN_STATE(state) {
      const { event } = getInitialState()
      state.event = event
    },
  },

  actions: {
    async fetchEventById({ commit }, id) {
      commit('CLEAN_STATE')
      const { data } = await axios.get(`/api/sales/events/${id}`)

      commit('SET_EVENT', {
        event: {
          ...data,
          storeId: String(data.storeId),
          priceTableId: String(data.priceTableId),
          startDate: splitDateTime(data.startDate),
          endDate: splitDateTime(data.endDate),
          skus: data.skus?.map(sku => ({
            ...sku,
            sku: {
              ...sku.sku,
              // id: String(sku.sku.id),
              value: sku.sku.id,
            },
          })),
        },
      })
    },
    setEventStoreId({ commit }, { storeId }) {
      commit('SET_EVENT_STORE_ID', { storeId })
    },

    async addProduct({ commit, state, dispatch }, { formData }) {
      const skuFound = state.event.skus.find(s => s.skuId === formData.skuId)
      if (skuFound) {
        dispatch('updateProduct', { formData: { ...skuFound, quantityAdded: formData.quantity } })
        return
      }

      const data = {
        ...formData,
      }
      const itemList = localListAddItem(state.event.skus, data)
      commit('SET_SKUS', { skus: itemList })
    },
    updateProduct({ commit, state }, { formData }) {
      const data = {
        ...formData,
        quantity: formData.quantity + (formData.quantityAdded || 0) - (formData.quantityRemoved || 0),
      }
      delete data.quantityAdded
      delete data.quantityRemoved
      const itemList = localListUpdateItem(state.event.skus, data)
      commit('SET_SKUS', { skus: itemList })
    },
    async removeProduct({ commit, state }, index) {
      // if (!id) throw new Error('Item sem id')
      // const itemList = localListDeleteItem(state.event.skus, id)
      const item = state.event.skus[index]

      if (state.event.id) {
        await axios.delete(`/api/sales/events/${state.event.id}/remove-sku/${item.skuId}`)
      }

      state.event.skus.splice(index, 1)

      commit('SET_SKUS', { skus: state.event.skus })
    },

    async addBannerAtm({ commit, state }, { payload }) {
      const itemList = localListAddItem(state.event.bannersAtm, payload)
      commit('SET_BANNERS_ATM', { bannersAtm: itemList })
    },
    updateBannerAtm({ commit, state }, { payload }) {
      const itemList = localListUpdateItem(state.event.bannersAtm, payload)
      commit('SET_BANNERS_ATM', { bannersAtm: itemList })
    },
    async removeBannerAtm({ commit, state }, { item }) {
      if (state.event.id) {
        await axios.delete(`/api/sales/events/${state.event.id}/banner-atm/${item.id}`)
      }

      const itemList = localListDeleteItem(state.event.bannersAtm, item.id || item.localId, true)

      commit('SET_BANNERS_ATM', { bannersAtm: itemList })
    },

    async saveEvent({ state }) {
      await axios({
        url: '/api/sales/events',
        method: state.event.id ? 'PUT' : 'POST',
        data: {
          ...state.event,
          startDate: joinDateTime(state.event.startDate, '00:00'),
          endDate: joinDateTime(state.event.endDate, '23:59'),
        },
      })
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
